/**
 * @generated SignedSource<<964dc6e5ada9b784110118f4ea88ea57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type onboardingPage_MagicLinkVerifyMutation$variables = {
  token: string;
};
export type onboardingPage_MagicLinkVerifyMutation$data = {
  readonly magicLinkVerify: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly token: string | null | undefined;
  } | null | undefined;
};
export type onboardingPage_MagicLinkVerifyMutation = {
  response: onboardingPage_MagicLinkVerifyMutation$data;
  variables: onboardingPage_MagicLinkVerifyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "onboardingPage_MagicLinkVerifyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MagicLinkVerifyMutationPayload",
        "kind": "LinkedField",
        "name": "magicLinkVerify",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "onboardingPage_MagicLinkVerifyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MagicLinkVerifyMutationPayload",
        "kind": "LinkedField",
        "name": "magicLinkVerify",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72f90ae7fa0bf52d5dc03c8a39b2b240",
    "id": null,
    "metadata": {},
    "name": "onboardingPage_MagicLinkVerifyMutation",
    "operationKind": "mutation",
    "text": "mutation onboardingPage_MagicLinkVerifyMutation(\n  $token: String!\n) {\n  magicLinkVerify(token: $token) {\n    token\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "41c030a40b7a30d28cbc9f613a45b599";

export default node;
